import React from "react";

import { HttpStatusCode, RouteConfig } from "@gamedev-web/gamedev-sdk-core";
import { UhfFooterMode, UhfHeaderMode } from "@gamedev-web/gamedev-uhf";

import { ErrorPage } from "../components";
import { localePickerPath } from "../constants/localePicker";
import { LocalePickerPage } from "../pages/LocalePicker";
import { updateRegisteredRoutes } from "./routeMatch";

const platformPreRoutes: RouteConfig[] = [
  {
    key: "LocalePicker",
    path: localePickerPath,
    component: LocalePickerPage,
    exact: true,
    testConfig: {
      title: "Locale Picker",
    },
  },
  {
    key: "HealthCheck",
    path: "/servicestatus/health",
    exact: true,
    uhfConfig: {
      headerMode: UhfHeaderMode.None,
      footerMode: UhfFooterMode.None,
    },
    isServerOnly: true,
    render: () => <div>OK</div>,
  },
];

const platformPostRoutes: RouteConfig[] = [
  {
    // fallback route to 404
    key: "404",
    render: () => (
      <ErrorPage error={new Error("Page not found.")} statusCode={HttpStatusCode.NotFound} />
    ),
  },
];

export const initializeRoutes = (partnerRoutes: RouteConfig[]) => {
  updateRegisteredRoutes([...platformPreRoutes, ...partnerRoutes, ...platformPostRoutes]);
};
